export const GC_USER_ID = 'graphcool-user-id'
export const GC_AUTH_TOKEN = 'graphcool-auth-token'
export const LINKS_PER_PAGE = 5
export const __SUBSCRIPTION_API_ENDPOINT__ = 'http://admin.ponceag.com/admin/api'
export const GoogleMapsKey = 'AIzaSyDEi2wgWpANAY4sttulylcvbtSfQ1Oxw88'
export const AppLink = 'http://test.ponceag.com'



// WEBPACK FOOTER //
// ./src/constants/settings.js